import React from "react"
import "./Member_Card.css"
import { getSocialMediaLogo, getDefaultSkin } from "../../util/Fetch_Item"


function MemberCard ({member, }) {

    // Creates an array of Social Media's the Member has
    var memberSocials  = []

    for(var social in member['socials'])
    {
        memberSocials.push(social)
    }

    // Used to render the Social Media Icons on the Member's Card this works in conjunction with the array memberSocials and socials array
    function getMemberSocials(social){
        if(member['socials'][social])
        {
            return(<a href={member['socials'][social]} ><img className="logo" src={getSocialMediaLogo(social)} alt = {social}/> </a> )
        }
        else
        {
            return (<></>)
        }
    }


    return (
        <div className="Member-Card-Container">
            
            {/* <img src={member["URL"]? member["URL"]: getDefaultSkin()} alt=""/> */}
            <img src={member["img"]? member["img"]: getDefaultSkin()} alt=""/>
            <div className="textbox" >
                <h3 className="Member-Role">
                    {member['role']?
                        <>
                            {member['role']}
                        </>
                    :
                        <>
                            Member
                        </>
                        
                    }
                </h3>
                <h2 className="Member-Name">
                    {member['name']}
                </h2> 
                
                
                {member['past names']?
                <>
                    <h4 className="Optional-Label"> Past Names: </h4>
                    {member['past names']}
                </>
                :
                <>
                </>
            }

            {
                member['past roles'] ? 
                <>
                    <h4 className="Optional-Label">Past Roles:</h4>
                    {member['past roles']}
                </>
                :
                <>
                </>
            }
            </div>
            <div className="socials">

                
                {member['socials']? 
                        <> 
                        {
                            memberSocials.map((socialMedia) => (
                            <>
                                {getMemberSocials(socialMedia)}
                            </>
                            ))
                        }
                    </>
                    :
                    <></>  
                }
            </div>
        </div>
    )
};

export default MemberCard;